import React, { FunctionComponent } from 'react';
import WithDataRecord from 'hoc/WithDataRecord';
import {
  AdminApi,
  AdminBundesbankSettlementInstructionsListRequest,
  AdminBundesbankSettlementInstruction,
  AdminBundesbankSettlementInstructionsListOrderingEnum,
} from 'api';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import SettlementsTable from './SettlementTable';

interface SettlementsTableProps extends AdminBundesbankSettlementInstructionsListRequest {
  defaultLimit?: number;
  forceDataLoad?: boolean;
  setForceDataLoad?: (val: boolean) => void;
  hasPermission: boolean;
}

const IssuerSettlementsTable: FunctionComponent<SettlementsTableProps> = WithDataRecord<
  AdminApi,
  AdminBundesbankSettlementInstruction
>(AdminApi)(
  ({ data, ordering, onOrderBy, loading, hasPermission, paginationProps }) => {
    const goTo = useGoTo(ISSUER_ROUTES.triggerSolutionsSettlementsDetails);

    return (
      <>
        <SettlementsTable
          loading={loading}
          hasPermission={hasPermission}
          onOrderBy={onOrderBy}
          ordering={ordering}
          goToDetails={(id: string) => goTo({ settlementId: id })}
          settlements={data}
          paginationProps={paginationProps}
        />
      </>
    );
  },
  (api, props, offset, limit, ordering) => {
    return api.adminBundesbankSettlementInstructionsList({
      offset,
      limit,
      ordering: ordering as AdminBundesbankSettlementInstructionsListOrderingEnum,
      ...props,
    });
  },
);

export default IssuerSettlementsTable;
